import { render } from "./btn-component.vue?vue&type=template&id=3e5de431&ts=true"
import script from "./btn-component.vue?vue&type=script&lang=ts"
export * from "./btn-component.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/FAST/develop/MidiRouter/projects/MidiRouterClient/midi-router-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__